// AddCheckInReminder.style.ts
import {Platform, StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {codGray, gallery} from '/theme/color/secondary.color';

const styles = StyleSheet.create({
  safeAreaContainer: {
    flex: 1,
    backgroundColor: gallery,
  },
  container: {
    flex: 1,
    backgroundColor: white,
    paddingHorizontal: 16,
    ...(Platform.OS === 'web' && {
      maxWidth: MAX_CONTENT_WIDTH,
      width: '100%',
      alignSelf: 'center',
    }),
  },

  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: indent * 0.8,
    marginTop: indent * 0.8,
  },
  backButton: {
    marginRight: indent * 0.4,
    fontSize: 24,
  },

  headerTitle: {
    color: codGray,
  },
});

export default styles;
